import { environmentVariables } from 'services/shared/Environment'
let stripe = null

if (!process.browser) {
  stripe = require("stripe")(environmentVariables().STRIPE_SECRET_API_KEY);
}
export default stripe
